module.exports = __webpack_public_path__ + "img/CU.e7c0a3a3.svg";